<div class="plate">
    <div class="qr">
        @if (safeSvg(); as svg) {
            <span [innerHTML]="svg"></span>
        } @else {
            <app-loader size="small" />
        }
    </div>
    <app-code>{{ code() }}</app-code>
</div>
